(() => {
  const ROYAL_PATH = '/collections/royal-pop-cases';
  const isRoyalCaseCollection = () => window.location.pathname.replace(/\/$/, '') === ROYAL_PATH;
  const explicitModel = () => new URL(window.location.href).searchParams.get('model');

  const syncRoyalSelection = (root) => {
    if (!isRoyalCaseCollection()) return;
    const selectedSlug = explicitModel();
    const scope = root._collectionSelectorDrawer || root;
    scope.querySelectorAll('[data-collection-selector-choice][data-config-platform="royal"]').forEach((choice) => {
      choice.classList.toggle('is-selected', Boolean(selectedSlug) && choice.dataset.configModel === selectedSlug);
    });
    document.dispatchEvent(new CustomEvent('royal-pop:model-change', { detail: { modelSlug: selectedSlug } }));
  };

  const setRoyalUrl = (slug) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('device');
    if (slug) url.searchParams.set('model', slug);
    else url.searchParams.delete('model');
    history.pushState({ royalPopModel: slug || null }, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const initCollectionSelectors = () => {
    document.querySelectorAll('[data-collection-selector-root]').forEach((root) => {
      if (root.dataset.collectionSelectorReady === 'true') { syncRoyalSelection(root); return; }
      root.dataset.collectionSelectorReady = 'true';
      const open = root.querySelector('[data-collection-selector-open]');
      const drawer = root.querySelector('[data-collection-selector-drawer]');
      if (!open || !drawer) return;

      // Move the modal surface to <body>. This prevents transformed or positioned
      // collection ancestors from trapping the fixed drawer in a lower stacking context.
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      root._collectionSelectorDrawer = drawer;

      const setOpen = (state) => {
        if (state && window.BrilintonSurfaceManager) {
          window.BrilintonSurfaceManager.register('collection-selector', {
            root: () => drawer,
            close: () => setOpen(false),
          });
          window.BrilintonSurfaceManager.open('collection-selector', {
            trigger: open,
            lockMode: 'overflow',
          });
        }
        root.classList.toggle('is-open', state);
        drawer.classList.toggle('is-open', state);
        drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
        open.setAttribute('aria-expanded', state ? 'true' : 'false');
        document.body.classList.toggle('collection-selector-open', state);
        if (!state && window.BrilintonSurfaceManager) {
          window.BrilintonSurfaceManager.close('collection-selector', { restoreFocus: true });
        }
      };
      open.addEventListener('click', () => setOpen(!root.classList.contains('is-open')));
      drawer.querySelectorAll('[data-collection-selector-close]').forEach((close) => close.addEventListener('click', () => setOpen(false)));
      drawer.querySelectorAll('[data-collection-selector-choice]').forEach((choice) => {
        choice.addEventListener('click', () => {
          const appleSize = choice.dataset.deviceSize || '';
          const royalSlug = choice.dataset.configModel || '';
          if (appleSize) window.BrilintonDeviceContext?.rememberAppleWatch({ size: appleSize }, 'legacy-collection-selector');
          if (royalSlug) window.BrilintonDeviceContext?.rememberRoyalPop(royalSlug, 'legacy-collection-selector');
          if (choice.tagName === 'A' && choice.getAttribute('href')) return;
          drawer.querySelectorAll('[data-collection-selector-choice].is-selected').forEach((el) => el.classList.remove('is-selected'));
          choice.classList.add('is-selected');
          if (choice.dataset.configPlatform === 'royal' && isRoyalCaseCollection()) {
            const slug = choice.dataset.configModel || '';
            setRoyalUrl(slug);
            document.dispatchEvent(new CustomEvent('royal-pop:model-change', { detail: { modelSlug: slug } }));
          }
          setOpen(false);
        });
      });
      syncRoyalSelection(root);

      // Open the Apple Watch Cases and Royal Pop Cases selector on first load.
      // The BandWare world selector remains closed by default.
      const selectorMode = root.dataset.collectionSelectorMode || '';
      const shouldOpenByDefault = selectorMode === 'apple-case' || selectorMode === 'royal-case';
      if (shouldOpenByDefault && root.dataset.collectionSelectorAutoOpened !== 'true') {
        root.dataset.collectionSelectorAutoOpened = 'true';
        const openAfterLayout = () => setOpen(true);
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(() => window.requestAnimationFrame(openAfterLayout));
        } else {
          window.setTimeout(openAfterLayout, 0);
        }
      }
    });
  };

  const closeOnEscape = (event) => {
    if (event.key !== 'Escape') return;
    if (window.BrilintonSurfaceManager?.isOpen('collection-selector')) {
      window.BrilintonSurfaceManager.closeTop('escape');
      return;
    }
    document.querySelectorAll('[data-collection-selector-root].is-open').forEach((root) => {
      root.classList.remove('is-open');
      const drawer = document.querySelector('[data-collection-selector-drawer].is-open');
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
      root.querySelector('[data-collection-selector-open]')?.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('collection-selector-open');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionSelectors);
  else initCollectionSelectors();
  document.addEventListener('shopify:section:load', initCollectionSelectors);
  window.addEventListener('popstate', initCollectionSelectors);
  if (!window.__collectionSelectorEscapeReady) { window.__collectionSelectorEscapeReady = true; document.addEventListener('keydown', closeOnEscape); }
})();